import { IapParams } from 'utils/iapParamValidation';

export const addCustomHazard = (
  hazards: string[],
  customHazard: string
): string[] => {
  if (customHazard) {
    return [...hazards, customHazard];
  }
  return hazards;
};

export const incrementParamsForUI = (params: IapParams) => ({
  ...params,
  phase: params.phase ? params.phase + 1 : 1,
});

export const decrementedParamsForCode = (params: IapParams) => ({
  ...params,
  phase: params.phase ? params.phase - 1 : 0,
});
